import React from 'react';


const FilterInput = ({ onChange }) => <input placeholder="Enter a name..." className="App-input" type="text" onChange={onChange} />;

export default FilterInput;



// WEBPACK FOOTER //
// ./src/components/FilterInput.jsx